// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cover-container {
  height: 70vw;
  margin-bottom: 12px;
}
.cover-container .cover {
  width: 70%;
  margin: 0 auto;
  margin-top: 25px;
}

.episode-author {
  margin-bottom: 2px;
}

.info-container {
  padding: 0 10%;
}

.music-controls {
  display: flex;
  justify-content: center;
  width: 100%;
}
.music-controls ion-fab-button.play-pause {
  --border-radius: 50%;
  --background: var(--cms-button-bg-color);
  --background-activated: var(--cms-button-bg-color);
}
.music-controls .controls {
  display: flex;
}
.music-controls ion-fab-button.back-time, .music-controls ion-fab-button.forward-time {
  font-size: 1em;
  --background: none;
  --background-activated: none;
  --color: black;
  --box-shadow: none;
}
.music-controls .forward-backward-buttons {
  --background: none;
  --background-activated: none;
  --color: black;
  --border-radius: 50%;
  --box-shadow: none;
}

.content-input-range {
  width: 100%;
}

.range-playtime {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}

image-loader {
  display: flex;
  justify-content: center;
}
image-loader ::ng-deep img {
  box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px;
}

toolbar-comments-likes {
  width: 100%;
  margin-top: 30px;
  padding: 0 10%;
}
toolbar-comments-likes ::ng-deep .bottom-toolbar-container {
  padding: 0 !important;
}

.center-player {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.download-button {
  --background: none;
  --color: black;
  margin-top: 18px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/episode-player/episode-player.page.scss"],"names":[],"mappings":"AAIA;EACI,YAAA;EACA,mBAAA;AAHJ;AAII;EACI,UAAA;EACA,cAAA;EACA,gBAAA;AAFR;;AAMA;EACI,kBAAA;AAHJ;;AAKA;EACI,cAAA;AAFJ;;AAIA;EAgBI,aAAA;EACA,uBAAA;EACA,WAAA;AAhBJ;AADI;EACI,oBAAA;EACA,wCAAA;EACA,kDAAA;AAGR;AADI;EACI,aAAA;AAGR;AADI;EACI,cAAA;EACA,kBAAA;EACA,4BAAA;EACA,cAAA;EACA,kBAAA;AAGR;AAGI;EACI,kBAAA;EACA,4BAAA;EACA,cAAA;EACA,oBAAA;EACA,kBAAA;AADR;;AAKA;EACI,WAAA;AAFJ;;AAIA;EACI,gBAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;AADJ;;AAIA;EACI,aAAA;EACA,uBAAA;AADJ;AAGQ;EACI,gFAAA;AADZ;;AAWA;EACI,WAAA;EACA,gBAAA;EACA,cAAA;AARJ;AAUQ;EACI,qBAAA;AARZ;;AAaA;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAVJ;;AAaA;EACI,kBAAA;EACA,cAAA;EACA,gBAAA;AAVJ","sourcesContent":["ion-content{\n    // --background: linear-gradient(315deg, #ffffff 0%, #d9e6fb 74%);\n}\n\n.cover-container{\n    height: 70vw;\n    margin-bottom: 12px;\n    .cover{\n        width: 70%;\n        margin: 0 auto;\n        margin-top: 25px;\n    }\n}\n\n.episode-author{\n    margin-bottom: 2px;\n}\n.info-container{\n    padding: 0 10%;\n}\n.music-controls{\n    ion-fab-button.play-pause{\n        --border-radius: 50%;\n        --background: var(--cms-button-bg-color);\n        --background-activated: var(--cms-button-bg-color);\n    }\n    .controls{\n        display: flex;\n    }\n    ion-fab-button.back-time, ion-fab-button.forward-time{\n        font-size: 1em;\n        --background: none;\n        --background-activated: none;\n        --color: black;\n        --box-shadow: none;\n    }\n    display: flex;\n    justify-content: center;\n    width: 100%;\n\n    .forward-backward-buttons{\n        --background: none;\n        --background-activated: none;\n        --color: black;\n        --border-radius: 50%;\n        --box-shadow: none;\n    }\n}\n\n.content-input-range{\n    width: 100%;\n}\n.range-playtime{\n    margin-top: 20px;\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n}\n\nimage-loader{\n    display: flex;\n    justify-content: center;\n    ::ng-deep{\n        img{\n            box-shadow: rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px;\n            // height: 40vh !important;\n            // width: 40vh !important;\n        }\n\n    }\n}\n\n\n\ntoolbar-comments-likes{\n    width: 100%;\n    margin-top: 30px;\n    padding: 0 10%;\n    ::ng-deep {\n        .bottom-toolbar-container {\n            padding: 0 !important;\n        }\n    }\n}\n\n.center-player{\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.download-button{\n    --background: none;\n    --color: black;\n    margin-top: 18px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
